/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getMyPreferences = getMyPreferences;
exports.get = get;
exports.getBool = getBool;
exports.makeGetCategory = makeGetCategory;
exports.getDirectShowPreferences = getDirectShowPreferences;
exports.getGroupShowPreferences = getGroupShowPreferences;

var _reselect = require('reselect');

var _preference_utils = require('../../utils/preference_utils');

var _constants = require('../../constants');

function getMyPreferences(state) {
    return state.entities.preferences.myPreferences;
} // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function get(state, category, name) {
    var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    var key = (0, _preference_utils.getPreferenceKey)(category, name);
    var prefs = getMyPreferences(state);

    if (!(key in prefs)) {
        return defaultValue;
    }

    return prefs[key].value;
}

function getBool(state, category, name) {
    var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    var value = get(state, category, name, String(defaultValue));

    return value !== 'false';
}

function makeGetCategory() {
    return (0, _reselect.createSelector)(getMyPreferences, function (state, category) {
        return category;
    }, function (preferences, category) {
        var prefix = category + '--';
        var prefsInCategory = [];

        for (var key in preferences) {
            if (key.startsWith(prefix)) {
                prefsInCategory.push(preferences[key]);
            }
        }

        return prefsInCategory;
    });
}

var getDirectShowCategory = makeGetCategory();

function getDirectShowPreferences(state) {
    return getDirectShowCategory(state, _constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW);
}

var getGroupShowCategory = makeGetCategory();

function getGroupShowPreferences(state) {
    return getGroupShowCategory(state, _constants.Preferences.CATEGORY_GROUP_CHANNEL_SHOW);
}



//////////////////
// WEBPACK FOOTER
// ./~/mattermost-redux/selectors/entities/preferences.js
// module id = 137
// module chunks = 60